export { default as facebookService } from './facebook-service'